"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import GradientText from "@/components/GradientText";

const HeaderNavClient = ({ navLinks }) => {
  const pathname = usePathname();

  return (
    <>
      {navLinks.map(({ name, href, download }) => {
        const isActive =
          pathname === href ||
          (href === "/product" && pathname.startsWith("/product/")) ||
          (href === "/blog" && pathname.startsWith("/blog/")) ||
          (href === "/brands" &&
            (pathname.startsWith("/brands/") || pathname.startsWith("/brand/")));
        const isExternal = href.startsWith("http");

        const content = isActive ? (
          <GradientText>{name}</GradientText>
        ) : (
          name
        );

        if (download || isExternal) {
          return (
            <a
              key={href}
              href={href}
              download={download ? "catalog.pdf" : undefined}
              target={isExternal && !download ? "_blank" : undefined}
              rel={isExternal && !download ? "noopener noreferrer" : undefined}
              className="hover:text-white transition-colors text-sm font-medium"
            >
              {content}
            </a>
          );
        }

        return (
          <Link
            key={href}
            href={href}
            className="hover:text-white transition-colors text-sm font-medium"
          >
            {content}
          </Link>
        );
      })}
    </>
  );
};

export default HeaderNavClient;


